"use strict";

exports.__esModule = true;
var _SelectionContextElement = require("./SelectionContextElement");
Object.keys(_SelectionContextElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectionContextElement[key]) return;
  exports[key] = _SelectionContextElement[key];
});
var _SelectionContextFields = require("./SelectionContextFields");
Object.keys(_SelectionContextFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectionContextFields[key]) return;
  exports[key] = _SelectionContextFields[key];
});
var _EditableSelectionContextElement = require("./EditableSelectionContextElement");
Object.keys(_EditableSelectionContextElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableSelectionContextElement[key]) return;
  exports[key] = _EditableSelectionContextElement[key];
});
var _SelectionContextThumbnail = require("./SelectionContextThumbnail");
Object.keys(_SelectionContextThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectionContextThumbnail[key]) return;
  exports[key] = _SelectionContextThumbnail[key];
});
var _SelectionContextHeader = require("./SelectionContextHeader");
Object.keys(_SelectionContextHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectionContextHeader[key]) return;
  exports[key] = _SelectionContextHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});